import { DealerRelatedUser } from '@api/types';
import { Column, StyledTableRowSeparator, TableCell, useDealerDetailsContext } from '@components';
import { Box, styled } from '@mui/material';
import { getUserItems } from './DealerDetails.config';

type DealerDetailsUserRowProps = {
  user: DealerRelatedUser;
  filteredColumns?: Array<Column>;
  visibleColumnNames?: Array<string>;
  isWorking?: boolean;
};

const StyledRow = styled(Box)`
  display: contents;
`;

export const DealerDetailsUserRow = ({
  user,
  visibleColumnNames,
  filteredColumns,
}: DealerDetailsUserRowProps) => {
  const { canEditData, isBerema } = useDealerDetailsContext();
  const userItems = getUserItems(user, canEditData, isBerema);
  const areAllFieldsFilled = (data: { fieldValue?: string | JSX.Element | null }[]) => {
    return data.some((item) => item.fieldValue !== null && item.fieldValue !== '');
  };

  if (!areAllFieldsFilled(userItems)) {
    return null;
  }

  return (
    <StyledRow>
      {userItems.map((userItem, index) => (
        <TableCell
          searchWords={[]}
          key={index}
          visibleColumnNames={visibleColumnNames}
          filteredColumns={filteredColumns}
          {...userItem}
        />
      ))}
      <StyledTableRowSeparator />
    </StyledRow>
  );
};
